import { combineReducers } from 'redux';

import lang from './lang';
import auth from './auth';
import token from './token';

// Global but will change per service
import allow_sessions from './sessions';

//Allow
import allow_users from '../services/allow/reducers/users';
import allow_companys from '../services/allow/reducers/companys';
import allow_pools from '../services/allow/reducers/pools';

//Willow
import willow_landing from '../services/willow/reducers/landing';

//Swallow
import swallow_landing from '../services/swallow/reducers/landing';
import swallow_quotes from '../services/swallow/reducers/quotes';
import swallow_projects from '../services/swallow/reducers/projects';
import swallow_versions from '../services/swallow/reducers/versions';

// env switch to pick right actions
const main_component = process.env.REACT_APP_MAIN;

let base = {
    lang,
    token,
    auth,
}

if (main_component === 'allow') {
    base = {
        ...base,
        allow_users,
        allow_companys,
        allow_pools,
        allow_sessions,
    }
}

if (main_component === 'willow') {
    base = {
        ...base,
        willow_landing,
    }
}

if (main_component === 'swallow') {
    base = {
        ...base,
        swallow_landing,
        swallow_quotes,
        swallow_projects,
        swallow_versions,
    }
}

export default combineReducers(base);